export { InstagramPreview as default } from './InstagramPreview';
